import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import Menu from "../../component/main_menu"
import { formatDate } from "../../utils/format_date"
import UserReserveModal from './user_reserve_modal';
import PushNotificationModal from './push_notification_modal';
import { useAuthContext } from '../../common/ProtectedLayout';

function User(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const [userList, setUserList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null); // 어떤 유저의 내역을 볼지 저장

    // Push Notification State
    const [pushModalOpen, setPushModalOpen] = useState(false);
    const [pushType, setPushType] = useState('all'); // 'all' or 'selected'
    const [isPushLoading, setIsPushLoading] = useState(false);

    const hadlePageChange = (page) => {
        setPage(page);
        setCheckedItems([]); // 페이지 변경 시 체크박스 초기화
    };

    const [checkedItems, setCheckedItems] = useState([]);  // 체크박스 관리
    const [searchQuery, setSearchQuery] = useState(''); // 검색어 상태

    const getUserRegist = async () => {
        try {
            const params = searchQuery.trim() !== '' ? { query: searchQuery } : {};
            const user_result = await axios.get('/UserRegist', { params });
            setUserList(user_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };

    useEffect(() => {
        setIsValidAccess(true);
        getUserRegist();
    }, [location.state, navigate]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    function checkValue(value) {
        return value ? value : "정보 없음";
    }

    // 체크박스 상태변화
    const handleCheckboxChange = (index) => {
        setCheckedItems(prevState => {
            const updatedCheckedItems = [...prevState];
            updatedCheckedItems[index] = !updatedCheckedItems[index];
            return updatedCheckedItems;
        });
    };

    // ✅ 모달 열기 핸들러 추가
    const handleViewMoreClick = (userId) => {
        setSelectedUserId(userId);
        setIsModalOpen(true);
    };

    // ✅ 모달 닫기 핸들러 추가
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedUserId(null);
    };

    // Push Notification Handlers
    const handlePushClick = (type) => {
        if (type === 'selected') {
            const hasChecked = checkedItems.some(item => item);
            if (!hasChecked) {
                alert("선택된 회원이 없습니다.");
                return;
            }
        }
        setPushType(type);
        setPushModalOpen(true);
    };

    const handleSendPush = async (title, message) => {
        setIsPushLoading(true);

        try {
            if (pushType === 'selected') {
                // 현재 페이지 기준으로 선택된 사용자 추출
                const currentPageUsers = userList.slice(items * (page - 1), items * (page - 1) + items);
                const selectedUsers = currentPageUsers.filter((_, index) => checkedItems[index]);
                const emailIds = selectedUsers.map(user => user.email_id);

                const response = await axios.post('/api/push/users/selected', {
                    email_ids: emailIds,
                    title: title,
                    body: message
                });

                if (response.data.success) {
                    alert(`${response.data.sent}명에게 푸시 알림이 전송되었습니다.\n(요청: ${response.data.requested}명, FCM 등록: ${response.data.found}명)`);
                } else {
                    alert(`푸시 발송 실패: ${response.data.message}`);
                }
            } else {
                // 전체 유저 푸시 (토픽 기반)
                const response = await axios.post('/api/push/users', {
                    title: title,
                    body: message
                });

                if (response.data.success) {
                    alert('전체 유저에게 푸시 알림이 전송되었습니다.');
                } else {
                    alert(`푸시 발송 실패: ${response.data.message}`);
                }
            }

            setPushModalOpen(false);
            setCheckedItems([]); // 체크박스 초기화
        } catch (error) {
            console.error('Push notification error:', error);
            const errorMessage = error.response?.data?.message || error.message || '알 수 없는 오류';
            alert(`푸시 발송 중 오류가 발생했습니다: ${errorMessage}`);
        } finally {
            setIsPushLoading(false);
        }
    };

    // 검색 핸들러
    const handleSearch = () => {
        setPage(1); // 검색 시 페이지를 1로 리셋
        getUserRegist();
    };

    // Enter 키 핸들러
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };


    return (
        <div className="dashboard-container">
            <div className="content-container">
                {/* 검색 UI */}
                <SearchContainer>
                    <SearchInput
                        type="text"
                        placeholder="아이디, 고객명, 전화번호, 주소로 검색..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <SearchButton onClick={handleSearch}>검색</SearchButton>
                </SearchContainer>
                <div className="small" style={{ marginTop: '20px', textAlign: 'center' }}>

                </div>
                <div style={{ marginTop: '10px' }}>
                    <CommonTable headerTitle={['선택', '아이디', '가입일자', '고객명', '연락처', '주소', '로그인방식', '디바이스', '더보기']}>
                        {
                            userList.slice(items * (page - 1), items * (page - 1) + items).map((userList, index) => {
                                return (
                                    <CommonTableRow key={index} idx={userList.idx} kind={'notDetail'} >
                                        <CommonTableColumn>
                                            <input
                                                type="checkbox"
                                                checked={!!checkedItems[index]}
                                                onChange={() => handleCheckboxChange(index)}
                                                style={{ transform: 'scale(2.0)' }} // ✅ 인라인 스타일로 크기 2배 확대
                                            />
                                        </CommonTableColumn>
                                        <CommonTableColumn>{userList.email_id}</CommonTableColumn>
                                        <CommonTableColumn>{formatDate(userList.regist_date)}</CommonTableColumn>
                                        <CommonTableColumn>{userList.user_name}</CommonTableColumn>
                                        <CommonTableColumn>{checkValue(userList.phone_num)}</CommonTableColumn>
                                        <CommonTableColumn>{checkValue(userList.address) + ' ' + (userList.address_sub ? userList.address_sub : "")}</CommonTableColumn>
                                        <CommonTableColumn>{userList.login_kind}</CommonTableColumn>
                                        <CommonTableColumn>{userList.device_kind}</CommonTableColumn>
                                        <CommonTableColumn>
                                            <button
                                                style={{ padding: '4px 8px', border: '1px solid #ccc', borderRadius: '3px', cursor: 'pointer' }}
                                                onClick={() => handleViewMoreClick(userList.email_id)} // ✅ 유저 ID 전달
                                            >
                                                더보기
                                            </button>
                                        </CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>

                    <ButtonContainer>
                        <PushButton onClick={() => handlePushClick('all')}>전체 푸쉬알림</PushButton>
                        <OutlinePushButton onClick={() => handlePushClick('selected')}>선택 푸쉬알림</OutlinePushButton>
                    </ButtonContainer>

                </div>
                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={userList.length - 1}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>
            {/* ✅ 모달 조건부 렌더링 */}
            {isModalOpen && selectedUserId && (
                <UserReserveModal
                    userId={selectedUserId}
                    onClose={handleCloseModal}
                    onWithdrawSuccess={() => {
                        handleCloseModal();
                        getUserRegist();
                    }}
                />
            )}
            <PushNotificationModal
                isOpen={pushModalOpen}
                onClose={() => setPushModalOpen(false)}
                onSend={handleSendPush}
                type={pushType}
                isLoading={isPushLoading}
            />
        </div >
    );

}


const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    gap: 10px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
`;

const PushButton = styled.button`
    background-color: #007bff;
    color: white;
    border: none;
    padding: 0.6rem 1.2rem;
    border-radius: 6px;
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #0056b3;
    }
`;

const OutlinePushButton = styled(PushButton)`
    background-color: white;
    color: #007bff;
    border: 1px solid #007bff;

    &:hover {
        background-color: #f0f8ff;
    }
`;

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 40px;
    margin-bottom: 10px;
    margin-left: 5%;
    width: auto;
    max-width: 500px;
`;

const SearchInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.2s;
    
    &:focus {
        outline: none;
        border-color: #006edc;
    }
    
    &::placeholder {
        color: #999;
    }
`;

const SearchButton = styled.button`
    padding: 12px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    
    &:hover {
        background-color: #0056b3;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

export default User;